import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './GradientHero.css';
import '../common-styles.css';
import d1 from '../../assets/images/diamonds-icons/d1.png';
import d2 from '../../assets/images/diamonds-icons/d2.png';
import d3 from '../../assets/images/diamonds-icons/d3.png';
import d4 from '../../assets/images/diamonds-icons/d4.png';
import d5 from '../../assets/images/diamonds-icons/d5.png';
import d6 from '../../assets/images/diamonds-icons/d6.png';
import d7 from '../../assets/images/diamonds-icons/d7.png';
import d8 from '../../assets/images/diamonds-icons/d8.png';
import d9 from '../../assets/images/diamonds-icons/d9.png';

export interface GradientHeroProps {
  backTo?: string;
  backLabel?: string;
  title: React.ReactNode;
  subtitleHighlight?: string;
  subtitleRest?: string;
  lead?: React.ReactNode;
  className?: string;
  titleClassName?: string;
  badgeText?: string; // standardized divider text (centered between lines)
}

/**
 * Reusable gradient hero used across detail pages (Diamonds, Artisans, etc.).
 * Keep visual consistency while allowing per-page content customization.
 */
const GradientHero: React.FC<GradientHeroProps> = ({
  backTo = '/',
  backLabel = 'Back',
  title,
  subtitleHighlight,
  subtitleRest,
  lead,
  className = '',
  titleClassName,
  badgeText
}) => {
  return (
    <section className={`gh-hero gradient-bg text-center ${className}`.trim()}>
      {/* Floating Diamond Decorations */}
      <div className="floating-diamonds" aria-hidden="true">
        <img src={d1} alt="" className="floating-diamond diamond-1" />
        <img src={d2} alt="" className="floating-diamond diamond-2" />
        <img src={d3} alt="" className="floating-diamond diamond-3" />
        <img src={d4} alt="" className="floating-diamond diamond-4" />
        <img src={d5} alt="" className="floating-diamond diamond-5" />
        <img src={d6} alt="" className="floating-diamond diamond-6" />
        <img src={d7} alt="" className="floating-diamond diamond-7" />
        <img src={d8} alt="" className="floating-diamond diamond-8" />
        <img src={d9} alt="" className="floating-diamond diamond-9" />
        <img src={d1} alt="" className="floating-diamond diamond-10" />
        <img src={d2} alt="" className="floating-diamond diamond-11" />
        <img src={d3} alt="" className="floating-diamond diamond-12" />
        <img src={d4} alt="" className="floating-diamond diamond-13" />
        <img src={d5} alt="" className="floating-diamond diamond-14" />
        <img src={d6} alt="" className="floating-diamond diamond-15" />
        <img src={d7} alt="" className="floating-diamond diamond-16" />
        <img src={d8} alt="" className="floating-diamond diamond-17" />
        <img src={d9} alt="" className="floating-diamond diamond-18" />
        <img src={d3} alt="" className="floating-diamond diamond-19" />
        <img src={d6} alt="" className="floating-diamond diamond-20" />
      </div>
      
      <Container>
        {backTo && (
          <div className="back-link-wrapper text-start">
            <Link to={backTo} className="back-link"><span>&larr; {backLabel}</span></Link>
          </div>
        )}
        <h1 className={`gh-hero-title section-title ${titleClassName || ''}`.trim()}>{title}</h1>
        {badgeText && (
          <div className="hero-divider"><span>{badgeText}</span></div>
        )}
        {(subtitleHighlight || subtitleRest) && (
          <h2 className="section-title">
            {subtitleHighlight && <span className="section-title-highlight">{subtitleHighlight}</span>}{subtitleRest}
          </h2>
        )}
        {lead && <p className="hero-lead">{lead}</p>}
      </Container>
    </section>
  );
};

export default GradientHero;
